import React from 'react';
import { Text } from '@leverege/ui-elements';
import { Blueprint } from '@leverege/molten/imagine';
import MapKeyItem from './MapKeyItem';
import S from './MapKey.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class MapKeyBody extends React.Component {
  render() {
    const {
      objectType
    } = this.props;
    const blueprint = Blueprint.getByType(objectType);
    let upperCaseObjectType, lowerCaseObjectType, lowBatteryText;
    if (objectType === 'vehicle') {
      upperCaseObjectType = 'Vehicle';
      lowerCaseObjectType = 'vehicle';
      lowBatteryText = 'The Locator paired with this vehicle has a low battery and must be replaced.';
    } else {
      upperCaseObjectType = 'Locator';
      lowerCaseObjectType = 'locator';
      lowBatteryText = 'The Locator has a low battery and must be replaced if it is currently paired with a vehicle.';
    }
    const positionAccuracyText = `The blue circle around the selected ${lowerCaseObjectType} indicates the potential area the ${lowerCaseObjectType} could be located based off of the accuracy of the position report.`;
    const stateText = `${upperCaseObjectType}s that meet multiple icon states will show the highest priority icon. Icons below are listed from highest priority to lowest priority.`;
    const activeTheftRecoveryText = `Theft Recovery Mode is activated for the ${lowerCaseObjectType}.`;
    const suspectedDriveOffText = 'Vehicle has been offsite for more than three days.';
    const inMotionText = `This ${lowerCaseObjectType} is in motion. The current position might be out of date.`;
    const pendingSaleText = 'This vehicle has been sold but requires an additional step. The action is either unpairing the locator or replacing the locator, depending on the type of sale.';
    const lostDriveOffText = 'This locator was not unpaired during a Vehicle Only sale and has left with the customer.';
    const staleLocationText = 'This position is over 48 hours old and is likely out of date.';
    const approxPositionText = `The accuracy of this position is greater than 100 meters. We recommend waiting for the following position update before trying to locate the ${lowerCaseObjectType}.`;
    const pendingSaleBlock = /*#__PURE__*/_jsx(MapKeyItem, {
      imgSrc: blueprint?.metadata?.icons?.mapbox?.pendingSale?.src,
      title: "Pending Sale",
      children: pendingSaleText
    });
    const lostDriveOffBlock = /*#__PURE__*/_jsx(MapKeyItem, {
      imgSrc: blueprint?.metadata?.icons?.mapbox?.lostDriveOff?.src,
      title: "Lost - Drive Off",
      children: lostDriveOffText
    });
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodyBold",
        children: "Position Accuracy"
      }), /*#__PURE__*/_jsx(MapKeyItem, {
        imgSrc: blueprint?.metadata?.icons?.mapbox?.normal?.src,
        imgBg: S.blueCircle,
        imgClass: S.iconCentered,
        title: `${upperCaseObjectType} Position Accuracy`,
        children: positionAccuracyText
      }), /*#__PURE__*/_jsxs(Text, {
        variant: "bodyBold",
        className: S.statesDescriptionHeader,
        children: [upperCaseObjectType, " States"]
      }), /*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: stateText
      }), /*#__PURE__*/_jsx(MapKeyItem, {
        imgSrc: blueprint?.metadata?.icons?.mapbox?.activeTheftRecovery?.src,
        title: "Active Theft Recovery",
        children: activeTheftRecoveryText
      }), /*#__PURE__*/_jsx(MapKeyItem, {
        imgSrc: blueprint?.metadata?.icons?.mapbox?.suspectedDriveOff?.src,
        title: "Suspected Drive Off",
        children: suspectedDriveOffText
      }), /*#__PURE__*/_jsx(MapKeyItem, {
        imgSrc: blueprint?.metadata?.icons?.mapbox?.inMotion?.src,
        title: "In Motion",
        children: inMotionText
      }), objectType === 'vehicle' ? pendingSaleBlock : '', objectType === 'locator' ? lostDriveOffBlock : '', /*#__PURE__*/_jsx(MapKeyItem, {
        imgSrc: blueprint?.metadata?.icons?.mapbox?.staleLocation?.src,
        title: "Stale Location",
        children: staleLocationText
      }), /*#__PURE__*/_jsx(MapKeyItem, {
        imgSrc: blueprint?.metadata?.icons?.mapbox?.lowAccuracy?.src,
        title: "Approximate Position",
        children: approxPositionText
      }), /*#__PURE__*/_jsx(MapKeyItem, {
        imgSrc: blueprint?.metadata?.icons?.mapbox?.lowBattery?.src,
        title: "Low Battery",
        children: lowBatteryText
      })]
    });
  }
}